<template>
    <div class="flex flex-1 flex-col items-center justify-center cursor-pointer group">
        <slot />
    </div>
</template>